import { ATTRIBUTE_PRODUCT_STATUS } from "../../../../../../../../../../../constants/attributeTypes.js";
import {
  PRODUCT_STATUS_ACTIVE, PRODUCT_STATUS_ARCHIVED,
  PRODUCT_STATUS_DRAFT
} from "../../../../../../../../../../../constants/shopifyProductStatuses.js";

export const getSelectValueOptions = (attribute) => {
  if(attribute === ATTRIBUTE_PRODUCT_STATUS) {
    return [
      { label: "Select", value: 'select' },
      { label: "Active", value: PRODUCT_STATUS_ACTIVE },
      { label: "Draft", value: PRODUCT_STATUS_DRAFT },
      { label: "Archived", value: PRODUCT_STATUS_ARCHIVED },
    ]
  }
}